
const ordersStyles = {
  container: {
    position: 'relative',
    border: '0px solid #ccc',
    borderRadius: '8px',
    padding: '20px 5px',
    margin: '10px',
    width: '250px',
    height: '380px',
    fontFamily: "'Exo 2', sans-serif",
    fontWeight: '400',
    color: 'white',
    overflow: 'hidden',
	boxSizing: 'border-box',
	zIndex: 2,
	cursor: 'pointer',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '50%',
    objectFit: 'cover',
    zIndex: 0,
	pointerEvents: 'none',
  },
  contentWrapper: {
    position: 'relative',
    zIndex: 1,
  },
  top: {
    display: 'flex',
	width: '100%',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: '5px 10px',
    borderRadius: '4px',
    marginTop: '-15px',
	boxSizing: 'border-box',
  },
  middle: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: '5px 10px',
    borderRadius: '4px',
    marginTop: '120px',
  },
  lower: {
  position: 'absolute',
  top: '50%',                  // ✅ starts at halfway point
  left: 0,
  width: '100%',
  padding: '10px',
  fontSize: '0.95em',
  boxSizing: 'border-box',
  zIndex: 1,
}
,
  bottom: {
  position: 'absolute',       
  bottom: '0px',              
  width: '100%',
  textAlign: 'center',
  fontSize: '0.9em',
  zIndex: 1,
  padding: '5px 10px',        
  boxSizing: 'border-box',    
},
};

export default ordersStyles;
